
<template>
  <div class="ph-compare-category">
    <el-backtop ></el-backtop>
    <hpheader v-if="showHeader"></hpheader>
    <ph-category></ph-category>
    <hpfooter></hpfooter>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import hpheader from '@/common/hpheader.vue'
import hpfooter from '@/common/hpfooter.vue'
import positionBar from '@/components/ph-position-bar.vue'
import {session} from "@/storage/storage"
import topBar from "@/components/compare/components/top-bar.vue";
import phCategory from "@/components/compare/ph-category.vue"
export default {
  components: {topBar,hpheader,hpfooter,positionBar, phCategory},
  data() {
    return {
      showHeader: true,
    };
  },
  methods: {
    ress(){
      var html = document.documentElement; //获取根元素
      var designWidth = 750; //设计稿宽度
      //html.clientWidth 视口宽度
      html.style.fontSize = html.clientWidth / designWidth * 100 + "px"; //设置字体大小
    },
  },
  created() {
    this.ress()
  },
  beforeDestroy() {
  }
};
</script>



<style scoped>

</style>